import { createContext, useContext, useEffect, useState } from "react";

const BasketContext = createContext(null);

export const BasketProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ukj_basket")) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("ukj_basket", JSON.stringify(items));
  }, [items]);

  const add = (deal, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.deal_id === deal.id);
      if (existing)
        return prev.map((i) => (i.deal_id === deal.id ? { ...i, qty: Math.min(i.qty + qty, deal.stock_remaining) } : i));
      return [...prev, { deal_id: deal.id, slug: deal.slug, title: deal.title, sku: deal.sku, price: deal.member_price, image: deal.images[0], max: deal.stock_remaining, qty }];
    });
  };
  const updateQty = (deal_id, qty) =>
    setItems((prev) => prev.map((i) => (i.deal_id === deal_id ? { ...i, qty: Math.max(1, Math.min(qty, i.max)) } : i)));
  const remove = (deal_id) => setItems((prev) => prev.filter((i) => i.deal_id !== deal_id));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <BasketContext.Provider value={{ items, add, updateQty, remove, clear, subtotal, count }}>
      {children}
    </BasketContext.Provider>
  );
};

export const useBasket = () => useContext(BasketContext);
